// extracted by mini-css-extract-plugin
export default {"cta":"I6icA"};